import { IPreloadedState } from 'shared/types/redux';

export const selectUser = (state: IPreloadedState) => state.user;
